export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14440.b93d540d.jpg";